module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_poland.9c0c58e3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_poland.png
// module id = 1245
// module chunks = 16